import {
  GET_PATIENT_NOTES,
  POST_PATIENT_NOTE,
  DELETE_OR_PATCH_NOTE
} from "resources/ApiUrls"
import MyAxiosInstance from "utils/MyAxiosInstance"

const getAll = (patientId) => MyAxiosInstance.get(GET_PATIENT_NOTES(patientId))

const create = (noteObj) => MyAxiosInstance.post(POST_PATIENT_NOTE, noteObj)

const remove = (noteId) => MyAxiosInstance.delete(DELETE_OR_PATCH_NOTE(noteId))

const update = (noteId, fieldsToUpdate) => MyAxiosInstance.patch(DELETE_OR_PATCH_NOTE(noteId), fieldsToUpdate)

const notesAPICalls = { getAll, create, remove, update }

export default notesAPICalls